import React from "react";
import { NumericFormat as NumberFormat } from "react-number-format";

type CurrencyFormateTextProps = {
  value?: number | string | null;
  renderText?: (_formattedValue: string) => React.ReactNode;
  prefix?: string;
  suffix?: string;
  decimalScale?: number;
  fixedDecimalScale?: boolean;
};

export const CurrencyFormateText = ({
  value,
  renderText,
  prefix = "$",
  suffix = "",
  decimalScale = 2,
  fixedDecimalScale = true,
}: CurrencyFormateTextProps) => {
  if (
    value === undefined ||
    value === null ||
    value === "" ||
    isNaN(value as number)
  ) {
    return null;
  }
  return (
    <NumberFormat
      value={value}
      displayType={"text"}
      thousandSeparator={true}
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      prefix={prefix}
      suffix={suffix}
      renderText={
        renderText
          ? renderText
          : (price) => <span className="currency">{price}</span>
      }
    />
  );
};
